import React from "react";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import { AddUser } from "../../components/AdminLayout/AddUser";

export const CreateUser = () => {
  const { t } = useTranslation();

  return (
    <>
      <div id="adminRoot">
        <AddHeader title={t("adduser")} />
        <AddUser />
      </div>
    </>
  );
};
